import {User} from '../../../shared/models';
import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators } from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { AssociationService } from '../../../shared/services/association.service';
import { UserService } from '../../../shared/services/user.service';
import { Association } from '../../../shared/models/association.model';
@Component({
  selector: 'app-user-new',
  templateUrl: './user-new.component.html',
  styleUrls: ['./user-new.component.css']
})
export class UserNewComponent implements OnInit {

  user: User = new User();
  userDetailsForm: FormGroup;
  roleOptionValue: null;
  associations: Association[];
  selectedAssoc: Association;
  assocLabel: string;

  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder,
              private associationService: AssociationService, private userService: UserService) {
    this.userDetailsForm = this.formBuilder.group({
      'firstname': ['', Validators.required],
      'name': ['', Validators.required],
      'email': ['', Validators.compose([Validators.required, Validators.email])],
      'alt_email':[''],
      'role': ['', Validators.required],
      'assocs': [''],
      'password': ['', Validators.required],
      'password_confirmation': ['', Validators.required],
    },
    {validator: this.checkIfMatchingPasswords('password', 'password_confirmation')});

    this.associationService.unFilteredList().subscribe(data => {
      this.associations = data;
    });

    this.onRoleChange();
  }

  ngOnInit() {
  }

  onUserDetailsSubmit(): void {
    (<any>Object).assign(this.user, this.userDetailsForm.value);

    const userObj = this.createUserObject(this.user);
    if (userObj && userObj.assocs) {
      this.userService.create('association', userObj)
                      .subscribe(data => this.activeModal.close('user-modal-success'), err => console.log(err));
    } else {
      this.userService.create('manager', userObj)
                      .subscribe(data => this.activeModal.close('user-modal-success'), err => console.log(err));
    }
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({notEquivalent: true});
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }

  onRoleChange() {
    this.userDetailsForm.get('role').valueChanges.subscribe(
      role => {
        if (role === 'association') {
          this.userDetailsForm.get('assocs').setValidators([Validators.required]);
          this.userDetailsForm.get('email').clearValidators();
        } else {
          this.userDetailsForm.get('assocs').clearValidators();
          this.userDetailsForm.get('email').setValidators([Validators.required]);
        }

        this.userDetailsForm.get('assocs').updateValueAndValidity();
        this.userDetailsForm.get('alt_email').updateValueAndValidity();
        this.userDetailsForm.get('email').updateValueAndValidity();
      });
  }

  createUserObject (userObj) {
    let newUserObj = null;
    if (userObj && userObj.role === 'manager') {
      newUserObj = {
        email: userObj.email,
        firstname: userObj.firstname,
        name: userObj.firstname,
        password: userObj.password,
        password_confirmation: userObj.password_confirmation
      }
    } else {
      newUserObj = {
        email: userObj.alt_email,
        firstname: userObj.firstname,
        name: userObj.name,
        password: userObj.password,
        password_confirmation: userObj.password_confirmation,
        alt_email: userObj.alt_email,
        assocs: this.selectedAssoc.id
      }
    }
    return newUserObj;
  }

  select(opt: Association) {
    this.selectedAssoc = opt;
  }

}
